import { render, staticRenderFns } from "./TableCalculations.vue?vue&type=template&id=8fe50eec&"
import script from "./TableCalculations.vue?vue&type=script&lang=ts&"
export * from "./TableCalculations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports